
import { Component, Vue, Prop } from 'vue-property-decorator';
import type { Template } from '@/shared/types/aperTemplate';

@Component
export default class TemplateDetails extends Vue {
  @Prop({ type: Object, required: true }) readonly template!: Template;
}
